/**
 * Maps API order status display names to i18n translation keys.
 * Used across OrdersPage, _base-order-modal, and anywhere order status needs translation.
 */
export const orderStatusMap = {
  "Awaiting Payment": "awaiting_payment",
  "Awaiting Shipment": "awaiting_shipment",
  "Cancel request pending": "cancel_request_pending",
  Cancelled: "cancelled",
  Delivered: "delivered",
  Draft: "draft",
  Dropship: "dropship",
  "Dropship processed": "dropship_processed",
  "Dropship Pending": "dropship_pending",
  "Local Dropship": "local_dropship",
  "On Hold": "on_hold",
  Processing: "processing",
  Shipped: "shipped",
  "VIN verification": "vin_verification",
  warehouse_allocation: "warehouse_allocation",
  "new Returns": "new_returns",
  "open Returns": "open_returns"
};

/**
 * Returns the i18n key for a given order status, or null if not found.
 * @param {string} status - Raw status from API
 * @returns {string|null}
 */
export function getOrderStatusKey(status) {
  return orderStatusMap[status] || null;
}
